/**
 * Check if the input value is undefined or null
 *
 * @param input
 * @return {boolean}
 */
export const isUndefinedOrNull = input => input === undefined || input === null;

/**
 * Check if the input value is an empty string
 *
 * @param input
 * @return {boolean}
 */
export const isEmptyString = input => typeof input === "string" && input.length === 0;

/**
 * @param array
 * @param depth
 * @return {any[]}
 */
export const flatten = (array, depth = 1) => {
    return repeat(depth, () => {
        array = [].concat.apply([], array);

        return array;
    });
};

/**
 * Repeat given callback x times also
 * passing to callback current
 * iteration number
 *
 * @param times
 * @param fn
 * @returns {any[]}
 */
export const repeat = (times, fn) =>
    Array.from({length: times}, (v, i) => i)
        .map(x => fn(x))
        .slice(-1)[0];

/**
 * @param array
 * @param path
 * @return {*}
 */
export const arrayPluck = (array, path) =>
    array.map(x => getObjectDot(path, x));


/**
 * Get object property
 *
 * @param path
 * @param object
 * @param defaultValue
 * @return {*}
 */
export const getObjectDot = (path, object, defaultValue = null) => {
    path.split(".").every(segment => {
        object = object[segment];
        return object;
    });
    return object || defaultValue;
};

export const toGermanNumberFormat = (number, part) => {
    return number.toFixed(part)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}


export const allPreOrders    = (limitOrders, locationId = false) => {
    if (!limitOrders.length) return 0;

    const preOrders = limitOrders.filter(function (order) {
        if (locationId) {
            return order.type === 1 && order.location_menu_category.location_id === locationId;
        }

        return order.type === 1;
    })
    return preOrders.reduce(function (acc, obj) {
        return acc + obj.quantity;
    }, 0);
}
export const pickedPreOrders = (limitOrders, locationId = false) => {
    if (!limitOrders.length) return 0;

    const pickedOrders = limitOrders.filter(function (order) {
        if (locationId) {
            return order.type === 1 && order.pickedup === 1 && order.location_menu_category.location_id === locationId;
        }

        return order.type === 1 && order.pickedup === 1;
    })
    return pickedOrders.reduce(function (acc, obj) {
        return acc + obj.quantity;
    }, 0);
}

export const allVoucherOrders = (voucherLimits, limitOrders, locationId = false) => {
    if (!voucherLimits || !limitOrders.length) return 0;

    let vouchersCountOrdersPerLocation = {};
    let totalPerLocation               = 0;

    for (let order of limitOrders) {
        if (order.type === 1) {
            for (let locationId in voucherLimits) {
                let voucherLimitsPerLocation = voucherLimits[locationId];

                for (let index in voucherLimitsPerLocation) {
                    let limit = voucherLimitsPerLocation[index];

                    if (order.location_menu_category.menu_category_id === limit.menu_category_id && order.location_menu_category.location_id === limit.location_id) {
                        if (typeof vouchersCountOrdersPerLocation[locationId] === 'undefined') {
                            vouchersCountOrdersPerLocation[locationId] = {};
                        }

                        if (typeof vouchersCountOrdersPerLocation[locationId][order.location_menu_category.menu_category_id] === 'undefined') {
                            vouchersCountOrdersPerLocation[locationId][order.location_menu_category.menu_category_id] = {'count': 0, 'percentage': limit.percentage};
                        }

                        vouchersCountOrdersPerLocation[locationId][order.location_menu_category.menu_category_id]['count'] += order.quantity;
                    }
                }
            }
        }
    }

    if (locationId) {
        if (vouchersCountOrdersPerLocation[locationId]) {
            for (let menuCategoryId in vouchersCountOrdersPerLocation[locationId]) {
                let countPerMenuCategory = vouchersCountOrdersPerLocation[locationId][menuCategoryId];

                totalPerLocation += Math.ceil(countPerMenuCategory.count * countPerMenuCategory.percentage / 100)
            }

            return totalPerLocation;
        } else {
            return 0;
        }
    }

    for (let locationId in vouchersCountOrdersPerLocation) {
        for (let menuCategoryId in vouchersCountOrdersPerLocation[locationId]) {
            let countPerMenuCategory = vouchersCountOrdersPerLocation[locationId][menuCategoryId];

            totalPerLocation += Math.ceil(countPerMenuCategory.count * countPerMenuCategory.percentage / 100)
        }
    }

    return totalPerLocation;
}

export const pickedVoucherOrders = (limitOrders, locationId = false) => {
    if (!limitOrders.length) return 0;

    const pickedVouchers = limitOrders.filter(function (order) {
        if (locationId) {
            return (order.type === 3 || order.type === 2) && order.pickedup === 1 && order.location_menu_category.location_id === locationId;
        }

        return (order.type === 3 || order.type === 2) && order.pickedup === 1;
    })
    return pickedVouchers.reduce(function (acc, obj) {
        return acc + obj.quantity;
    }, 0);
}
